/* eslint-disable react/no-array-index-key */
import React from 'react';

import Heading from 'Components/Heading/Heading';
import Summary from 'Components/Summary/Summary';
import Common from '../Common/Common';
import operationsBrain from '../../Assets/elvotaimages/operations_brain.png';
import optimalCharge from '../../Assets/elvotaimages/operations_optimal_charge.png';
import riskImage from '../../Assets/elvotaimages/operations_risk_management.png';
import allways247 from '../../Assets/elvotaimages/operations_247.png';
import bgImage from '../../Assets/elvotaimages/Group100.png';

export default function OperationalServices() {
  const contentValues = [
    {
      heading: 'ADVANCED AI FORECASTING',
      paragraph:
        'Our state-of-the-art AI algorithms provide precise time series forecasting for electricity prices, loads, and generation. This accuracy ensures optimal decision-making for your BESS operations.',
      imageSrc: operationsBrain,
    },
    {
      heading: 'OPTIMAL CHARGE/ DISCHARGE MANAGEMENT',
      paragraph:
        'We use real-time data and predictive analytics to determine the best times for charging and discharging your BESS. This maximizes your revenue and extends the lifespan of your assets.',
      imageSrc: optimalCharge,
    },
    {
      heading: 'MARKET RISK MANAGEMENT',
      paragraph:
        'Our sophisticated models identify electricity price peaks and market risks, allowing us to navigate the market confidently. This minimizes risks and maximizes returns for your energy storage investments.',
      imageSrc: riskImage,
    },
    {
      heading: '24/7 MONITORING & SUPPORT',
      paragraph:
        'Our dedicated team provides round-the-clock monitoring and support, ensuring your BESS operates at peak efficiency at all times. We are always here to help you achieve the best performance and reliability.',
      imageSrc: allways247,
    },
  ];
  const summaryContent = [
    'Our AI-powered real-time optimization service is designed to maximize the performance and longevity of your battery energy storage system (BESS). By integrating advanced forecasting algorithms with optimal charge/discharge management, market risk analysis, and 24/7 monitoring, we ensure that your assets are always operating at peak efficiency.',
    'Our solution helps you navigate volatile markets, minimise risks and unlock the full revenue potential of your BESS, all while extending asset lifespan and providing round-the-clock support.',
  ];
  return (
    <div>
      <Heading content="AI-powered operations service" />
      <div className="pb-[40px]">
        <Summary paragraph={summaryContent} />
      </div>
      <div
        className="relative z-0" // Make sure the div is positioned relatively
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain', // Ensure the image is fully contained within the section
          backgroundPosition: 'center', // Center the image
          backgroundRepeat: 'no-repeat', // Prevent image from repeating
          padding: '40px 0', // Add padding for spacing
        }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-12 lg:gap-16">
          {contentValues.map((value, index) => (
            <div key={index} className="flex h-full">
              <Common
                heading={value.heading}
                paragraph={value.paragraph}
                imageSrc={value.imageSrc}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
